import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import Loader from './Loader'

import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';

import CustomDialog from './inputs/CustomDialog'
import QuestionPreview from './QuestionPreview'
import InstaTable from './InstaTable'

import {
  questions_index,
  preferences_index,
  users_select,
  duplicate_question,
  publish_question,
  unpublish_question,
  trash_question,
  delete_question,
  reset_question,
  questions_xlsx,
  clear_question,
  set_path
} from '../actions'

import {
  is_logged_on,
  is_validating,
  renderBody,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals } = state.question
  return {
    questions: items,
    pagination: pagination,
    totals: totals,
    current_user: state.auth.current_user.data,
    skills: state.skill.items,
    competencies: state.competency.items,
    levels: state.preference.levels,
    tags: state.tag.items,
    users: state.user.select_items,
    setStatus: state.question.set_status,
    fetching: state.question.fetching,
    fetched: state.question.fetched,
    mounted: false
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getQuestions: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( questions_index(page, per_page, filters, sort, order) ),
    questionsXLSX: (filters, sort, order, variant) => dispatch ( questions_xlsx(filters, sort, order, variant) ),
    duplicateQuestion: (question_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(duplicate_question(question_id, index, page, per_page, filters, sort, order)),
    publishQuestion: (question_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(publish_question(question_id, index, page, per_page, filters, sort, order)),
    unpublishQuestion: (question_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(unpublish_question(question_id, index, page, per_page, filters, sort, order)),
    trashQuestion: (question_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(trash_question(question_id, index, page, per_page, filters, sort, order)),
    deleteQuestion: (question_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(delete_question(question_id, index, page, per_page, filters, sort, order)),
    resetQuestion: () => dispatch( reset_question() ),
    clearQuestion: () => dispatch( clear_question() ),
    getPreferences: () => dispatch( preferences_index() ),
    getUsers: () => dispatch( users_select() ),
    setPath: path => dispatch( set_path(path) )
  }
}

class ConnectedQuestionsIndex extends React.Component {
  state={
    showDialog: false,
    showPreview: false,
    previewId: '',
    current_id: undefined,
    current_view: 'all',
    merge_filters: {},
    initFilters: {},
    filterState: {},
  }

  fieldGetter(field, item, instate) {
    let renderText
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters
      }
    }
    if (field === "created_at" || field === "updated_at") {
      renderText = new Date(item[field]).toLocaleDateString()
    } else if ( field === "status" ) {
      const { active, trash } = item
      const theStatus = trash ? 'trash' : active ? 'published' : 'draft'
      renderText = this.statusIcon(theStatus)
    } else if (field === 'creator') {
      renderText = item.creator ? item.creator.display_name : ''
    } else if (field === 'skill') {
      renderText = item.skill ? item.skill.name : ''
    } else if (field === 'competency') {
      renderText = item.competency ? item.competency.name : ''
    } else if (field === 'level') {
      renderText = item.level ? item.level.name : ''
    } else if (field === 'body') {
      renderText = renderBody(item[field], 135)
    } else if (field === 'tags') {
      renderText = (item[field] && item[field] !== null) ? item[field].map( (t, i) => (
        <div key={`inline_tag_${i}`}>{t.label}</div>
      )) : ''
    } else if (["a1", "a2", "b1", "b2", "c1", "c2"].indexOf(field) > -1) {
      renderText = item.total_right > 0 ? `${Math.round( (100 * item[field]) / item.total_right )} %` : '0 %'
    } else if (field === "actions" ) {
      const {active, trash} = item
      renderText = this.props.questionbase === 'index' ? (
        <React.Fragment>
          {(!active && !trash) && this.editLink(item)}
          {(active) && this.unpublishLink(item, state)}
          {(!active && !trash) && this.publishLink(item, state)}
          {(!active && !trash) && this.trashLink(item, state)}
          {(trash) && this.recoverLink(item, state)}
          {(trash) && this.deleteLink(item, state)}
          { this.duplicateLink(item, state) }
        </React.Fragment>
      ) : ''
    } else if (field === "served" || field === "seconds" || field === 'id' || field === 'group_id'){
      renderText = item[field]
    } else if ( field === "avg_right" ) {
      renderText = item.served > 0 ? `${Math.round( (100 * item.total_right) / item.served )} %` : '0 %'
    } else if ( field === "avg_seconds" ) {
      renderText = item.served > 0 ? Math.round(item.total_time / item.served) : 0
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getQuestions, current_user, getPreferences, getUsers, location, user_id } = this.props
    let filters = {}

    if ( location && location.state && location.state.skill ) {
      filters = {
        skill: location.state.skill
      }
    } else if ( location && location.state && location.state.competency ) {
      filters = {
        competency: location.state.competency
      }
    }

    if ( user_id && user_id !== null ) {
      filters = {
        ...filters,
        creator: user_id
      }
    }

    this.setState({merge_filters: filters, initFilters: filters})

    getQuestions(1, 10, filters)
    getPreferences()

    if (current_user.role === "admin" || current_user.role === "expert") {
      getUsers()
    }
  }

  componentWillUnmount() {
    this.props.resetQuestion()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.setStatus) {
      this.props.resetQuestion()
    }
    if (!this.state.mounted) {
      if (!this.props.fetching && this.props.fetched) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else if (value === 'active') {
      this.setState({merge_filters: {active: true}})
    } else if (value === 'draft') {
      this.setState({merge_filters: {active: false}})
    } else if (value === 'trash') {
      this.setState({merge_filters: {trash: true}})
    } else {
      return
    }
    this.setState({current_view: value})
  }

  editLink = question => {
    const {id} = question
    return (
      <Link to ={`/questions/${id}/edit`} className="action-btn" title="Edit" onClick={this.props.clearQuestion}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>create</Icon>
      </Link>
    )
  }

  duplicateLink = (question, state) => {
    const {id} = question
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Duplicate" onClick={e=>{
          e.preventDefault()
          this.props.duplicateQuestion(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>content_copy</Icon>
      </Link>
    )
  }

  unpublishLink = (question, state) => {
    const {id, creator} = question
    if (!creator) {
      return ''
    }
    const {current_user} = this.props
    if (
        current_user.role === "admin" || current_user.role === "expert"
    ) {
      const {filters, sort, order, page, per_page} = state
      return (
        <Link to="" className="action-btn" title="Unpublish to draft" onClick={e=>{
          e.preventDefault()
          this.props.unpublishQuestion(id, true,  page, per_page, filters, sort, order)
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>insert_drive_file</Icon>
        </Link>
      )
    }
    return ''

  }

  publishLink = (question, state) => {
    const {id, creator} = question
    if (!creator) {
      return ''
    }
    const {current_user} = this.props
    if (
        current_user.role === "admin" || current_user.role === "expert"
    ) {
      const {filters, sort, order, page, per_page} = state
      return (
        <Link to="" className="action-btn" title="Publish" onClick={e=>{
            e.preventDefault()
            this.props.publishQuestion(id, true,  page, per_page, filters, sort, order)
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>check_circle</Icon>
        </Link>
      )
    }
    return ''
  }

  trashLink = (question, state) => {
    const {id} = question
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Move to trash" onClick={e=>{
          e.preventDefault()
          this.props.trashQuestion(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>delete</Icon>
      </Link>
    )
  }

  deleteLink = (question, state) => {
    const {id, creator} = question
    if (!creator) {
      return ''
    }
    const {current_user} = this.props
    if (
      current_user.role === "admin" || current_user.role === "expert"
    ) {
      return (
        <Link to="" className="action-btn" title="Permanently delete" onClick={e=>{
            e.preventDefault()
            this.setState({showDialog: true, current_id: id, filterState: state})
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>delete_forever</Icon>
        </Link>
      )
    }
    return ''
  }

  destroy = id => {
    // console.log(this.state.filterState)
    const {filters, sort, order, page, per_page} = this.state.filterState
    this.props.deleteQuestion(id, true,  page, per_page, filters, sort, order)
    this.hideDialog()
    this.setState({filterState: {}})
  }

  hideDialog() {
    this.setState({showDialog: false, showPreview: false, previewId: ''})
  }

  recoverLink = (question, state) => {
    const {id} = question

    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Restore" onClick={e=>{
          e.preventDefault()
          this.props.unpublishQuestion(id, true,  page, per_page, filters, sort, order)
        }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>restore_page</Icon>
      </Link>
    )

  }

  statusIcon = status => {
    if (status === 'trash') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="In Trash">delete</Icon>
    } else if (status === 'published') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Published">check_circle</Icon>
    } else if (status === 'draft') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Draft">insert_drive_file</Icon>
    }
  }

  showPreview = (item, field, state) => {
    const { filters, sort, order } = state
    this.setState({showPreview: true, previewId: item.id, previewFilters: filters, previewSort: sort, previewOrder: order})
  }

  headerButton = (filters, sort, order) => {
    if (this.props.current_user.role !== "admin") {
      return ''
    }
    return (
      <Hidden smDown>
        <a href='' style={{float: 'right'}} onClick={e => {
          e.preventDefault()
          this.props.questionsXLSX(filters, sort, order, this.props.questionbase)
        }}>
          Download XLSX
        </a>
      </Hidden>
    )
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( ["creator", "expert", "admin"].indexOf(role) < 0 ) {
      return <Redirect to="/" />
    }

    if (this.props.questionbase === 'results' && role === 'creator') {
      return <Redirect to="/" />
    }

    const { questions, pagination, skills, competencies, levels, tags, users, totals, fetching } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true, minWidth: this.props.questionbase === 'results' ? 72 : undefined },
      { id: 'body', disablePadding: true, label: 'Question', visible: "results" },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true, visible: "results" },
      { id: 'skill', disablePadding: true, label: 'Skill', requires: ['admin'] },
      { id: 'competency', disablePadding: true, label: 'Competency' },
      { id: 'level', disablePadding: true, label: 'CEFR' },
      { id: 'question_type', disablePadding: true, label: 'Type' },
      { id: 'group_id', disablePadding: true, label: 'Sibling ID', visible: "index" },
      { id: 'body', disablePadding: true, label: 'Question', visible: "index" },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true, visible: "index" },
      { id: 'creator', disablePadding: true, label: 'User', requires: ['expert', 'admin'], visible: "index" },
      { id: 'served', disablePadding: true, label: '# Served', visible: "results" },
      { id: 'avg_right', disablePadding: true, label: 'Right', visible: "results" },
      { id: 'a1', disablePadding: true, label: 'Result A1', visible: "results" },
      { id: 'a2', disablePadding: true, label: 'Result A2', visible: "results" },
      { id: 'b1', disablePadding: true, label: 'Result B1', visible: "results" },
      { id: 'b2', disablePadding: true, label: 'Result B2', visible: "results" },
      { id: 'c1', disablePadding: true, label: 'Result C1', visible: "results" },
      { id: 'c2', disablePadding: true, label: 'Result C2', visible: "results" },
      { id: 'seconds', disablePadding: true, label: 'Time Exp.(s)', visible: "results" },
      { id: 'avg_seconds', disablePadding: true, label: 'Time Avg.(s)', visible: "results" },
      { id: 'tags', disablePadding: true, label: 'Tags', disableSort: true },
      { id: 'created_at', disablePadding: true, label: 'Creation Date', visible: "index" },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true, visible: "index" },

    ].filter( c => c.requires === undefined || c.requires.indexOf(role) > -1 ).filter(
      c => c.visible === undefined || c.visible === this.props.questionbase
    )

    const filterControls = [
      { name: "skill", filter_type: "select", valueField: "name", collection: skills, requires: ['admin'] },
      { name: "competency", filter_type: "select", valueField: "name", collection: competencies },
      { name: "level", filter_type: "select", label: "CEFR", valueField: "name", collection: levels },
      { name: "question_type", filter_type: "select", label: "Type", valueField: "name", collection: ["audio", "image", "text"] },
      { name: "creator", filter_type: "select", label: "User", valueField: "display_name", collection: users, requires: ['expert', 'admin'], visible: "index" },
      { name: "tag", filter_type: "select", valueField: "name", collection: tags.filter( t => t.questions > 0) },
      { name: "created_at", filter_type: "date", visible: "index" },
      { name: "search", filter_type: "search", visible: "results" }
    ].filter( c => c.requires === undefined || c.requires.indexOf(role) > -1 ).filter(
      c => c.visible === undefined || c.visible === this.props.questionbase
    )

    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "active", label: "Published", value: totals.active },
      { name: "draft", label: "Draft", value: totals.draft },
      { name: "trash", label: "Trash", value: totals.trash },
    ]

    return (
      <div id="questions-wrapper" className={fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            {this.props.header || 'Questions'}
          </Typography>
          {
            this.props.questionbase === "index" && (
              <CustomOutlinedButton
                component={Link}
                to="/questions/new"
                className="buttonnoto c-blue align-self-center"
                onClick={e=> this.props.setPath("newquestion")}
                >Add Question
              </CustomOutlinedButton>
            )
          }
        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={questions}
          pagination={pagination}
          role={role}
          search={true}
          placeholders="ID, Question, Sibling"
          init_filters={this.state.initFilters}
          merge_filters={this.state.merge_filters}
          rowGetter={this.props.getQuestions.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          previewColumn="body"
          clearItem={this.props.clearQuestion.bind(this)}
          previewItem={this.showPreview.bind(this)}
          classPrefix="question"
          addClassField="status"
          headerButton={this.headerButton.bind(this)}
        />

        <CustomDialog
          id="delete-dialog"
          fullScreen = {false}
          qid={this.state.current_id}
          isopen={this.state.showDialog}
          handleClose={this.hideDialog.bind(this)}
          handleAccept={this.destroy.bind(this)}
          title="Delete Question?"
        >
          This action cannot be undone
        </CustomDialog>
        <QuestionPreview
          id="preview-dialog"
          filters={{...this.state.previewFilters, ...this.state.merge_filters}}
          sort={this.state.previewSort}
          order={this.state.previewOrder}
          isopen={this.state.showPreview}
          question_id={this.state.previewId}
          handleClose={this.hideDialog.bind(this)}
        />
      </div>
    )
  }
}

const QuestionsIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedQuestionsIndex)

export default withStyles(styles)(QuestionsIndex)



// WEBPACK FOOTER //
// ./src/js/components/QuestionsBase.js